const base = (process.env.REACT_APP_API_URL || 'http://localhost:8000/api').replace(/\/$/, '');

export async function request(endpoint, token, body, signal) {
  const response = await fetch(`${base}${endpoint}`, {
    method: body ? 'POST' : 'GET',
    headers: { Authorization: `Bearer ${token}`, ...(body ? { 'Content-Type': 'application/json' } : {}) },
    ...(body ? { body: JSON.stringify(body) } : {}), signal,
  });
  const data = await response.json();
  if (!response.ok) {
    const detail = Array.isArray(data.detail) ? data.detail.map(d => d.msg).join('; ') : data.detail;
    throw new Error(response.status === 401 ? 'Your session has expired. Sign in again.' : detail || 'The request failed.');
  }
  return data;
}
